exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ItemsWrapper__wrapper___3cI0-{max-height:196px;overflow-y:auto}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "ItemsWrapper__wrapper___3cI0-"
};